import { useState } from 'react';
import { Link } from 'react-router-dom';

interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  readTime: string;
  category: string;
}

export default function BlogPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const blogPosts: BlogPost[] = [
    {
      id: 1,
      title: "Classic Bloody Mary with a Southern Twist",
      excerpt: "Discover the perfect balance of spice and flavor with our signature recipe. This classic cocktail gets elevated with our premium mix and traditional Southern garnishes that will make your brunch unforgettable.",
      image: "https://public.readdy.ai/ai/img_res/26c8c560042786b64152cb87fe4a5b19.jpg",
      date: "March 15, 2024",
      readTime: "5 min read",
      category: "Cocktails"
    },
    {
      id: 2,
      title: "Spicy Shrimp Bloody Mary Shooters",
      excerpt: "Perfect for parties and gatherings, these bite-sized shooters combine our Bloody Mary mix with succulent grilled shrimp. A crowd-pleasing appetizer that brings bold Southern flavors to your entertaining spread.",
      image: "https://readdy.ai/api/search-image?query=small%20shot%20glasses%20filled%20with%20red%20bloody%20mary%20mix%20topped%20with%20grilled%20shrimp%20garnish%20arranged%20on%20white%20serving%20platter%20with%20fresh%20herbs%20and%20lime%20wedges%20in%20bright%20kitchen%20setting&width=800&height=600&seq=blog2&orientation=landscape",
      date: "March 10, 2024",
      readTime: "7 min read",
      category: "Appetizers"
    },
    {
      id: 3,
      title: "Bloody Mary Brunch Skewers",
      excerpt: "Transform your brunch spread with these creative skewers featuring cherry tomatoes, mozzarella, olives, and pickles marinated in our Bloody Mary mix. A fresh take on caprese that adds Southern flair to your table.",
      image: "https://readdy.ai/api/search-image?query=colorful%20appetizer%20skewers%20with%20cherry%20tomatoes%20mozzarella%20balls%20olives%20and%20pickles%20on%20white%20marble%20surface%20with%20fresh%20basil%20leaves%20and%20small%20bowl%20of%20red%20marinade%20in%20natural%20daylight&width=800&height=600&seq=blog3&orientation=landscape",
      date: "March 5, 2024",
      readTime: "6 min read",
      category: "Brunch"
    },
    {
      id: 4,
      title: "Bloody Mary Glazed Chicken Wings",
      excerpt: "Take your game day snacks to the next level with these sticky, spicy wings glazed with our Bloody Mary mix. The perfect combination of tangy, savory, and spicy that will have everyone asking for the recipe.",
      image: "https://readdy.ai/api/search-image?query=crispy%20glazed%20chicken%20wings%20with%20shiny%20red%20coating%20on%20black%20slate%20serving%20board%20with%20celery%20sticks%20and%20ranch%20dipping%20sauce%20in%20modern%20kitchen%20with%20dramatic%20lighting&width=800&height=600&seq=blog4&orientation=landscape",
      date: "February 28, 2024",
      readTime: "8 min read",
      category: "Main Dishes"
    },
    {
      id: 5,
      title: "Bloody Mary Gazpacho Soup",
      excerpt: "A refreshing cold soup that combines the best of Spanish gazpacho with our signature Bloody Mary flavors. Perfect for hot summer days when you want something light yet packed with bold Southern taste.",
      image: "https://readdy.ai/api/search-image?query=chilled%20red%20gazpacho%20soup%20in%20white%20ceramic%20bowl%20garnished%20with%20diced%20vegetables%20and%20herbs%20on%20light%20linen%20tablecloth%20with%20fresh%20tomatoes%20and%20cucumber%20in%20soft%20natural%20light&width=800&height=600&seq=blog5&orientation=landscape",
      date: "February 20, 2024",
      readTime: "6 min read",
      category: "Soups"
    },
    {
      id: 6,
      title: "Bloody Mary Marinated Steak",
      excerpt: "Elevate your grilling game with this tender, flavorful steak marinated overnight in our Bloody Mary mix. The acidity and spices create the perfect crust while keeping the meat juicy and delicious.",
      image: "https://readdy.ai/api/search-image?query=perfectly%20grilled%20ribeye%20steak%20with%20beautiful%20char%20marks%20on%20wooden%20cutting%20board%20with%20fresh%20rosemary%20and%20garlic%20cloves%20in%20warm%20ambient%20lighting%20with%20blurred%20background&width=800&height=600&seq=blog6&orientation=landscape",
      date: "February 15, 2024",
      readTime: "10 min read",
      category: "Main Dishes"
    },
    {
      id: 7,
      title: "Bloody Mary Deviled Eggs",
      excerpt: "A Southern classic gets a spicy makeover! These deviled eggs are infused with our Bloody Mary mix for a tangy, zesty appetizer that's perfect for any gathering or potluck.",
      image: "https://readdy.ai/api/search-image?query=elegant%20deviled%20eggs%20with%20paprika%20garnish%20arranged%20on%20vintage%20white%20serving%20platter%20with%20fresh%20dill%20and%20lemon%20slices%20on%20light%20marble%20surface%20in%20soft%20natural%20lighting&width=800&height=600&seq=blog7&orientation=landscape",
      date: "February 10, 2024",
      readTime: "5 min read",
      category: "Appetizers"
    },
    {
      id: 8,
      title: "Bloody Mary Pasta Salad",
      excerpt: "This vibrant pasta salad brings together fresh vegetables, tender pasta, and our zesty Bloody Mary mix for a side dish that steals the show at picnics and barbecues.",
      image: "https://readdy.ai/api/search-image?query=colorful%20pasta%20salad%20with%20cherry%20tomatoes%20bell%20peppers%20and%20fresh%20herbs%20in%20large%20glass%20bowl%20on%20outdoor%20picnic%20table%20with%20checkered%20cloth%20in%20bright%20sunny%20daylight&width=800&height=600&seq=blog8&orientation=landscape",
      date: "February 5, 2024",
      readTime: "7 min read",
      category: "Sides"
    },
    {
      id: 9,
      title: "Bloody Mary Oyster Shooters",
      excerpt: "For the adventurous palate, these elegant oyster shooters combine fresh oysters with our premium mix. A sophisticated appetizer that brings coastal flavors to your Southern table.",
      image: "https://readdy.ai/api/search-image?query=fresh%20oysters%20in%20small%20shot%20glasses%20with%20red%20bloody%20mary%20mix%20and%20lemon%20wedges%20on%20ice-filled%20serving%20tray%20with%20elegant%20presentation%20in%20upscale%20restaurant%20setting&width=800&height=600&seq=blog9&orientation=landscape",
      date: "January 30, 2024",
      readTime: "6 min read",
      category: "Appetizers"
    }
  ];

  const categories = ["All", "Cocktails", "Appetizers", "Brunch", "Main Dishes", "Soups", "Sides"];
  const [selectedCategory, setSelectedCategory] = useState("All");

  const filteredPosts = selectedCategory === "All" 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <Link to="/" className="flex items-center">
              <h1 className="text-2xl font-bold text-white">
                Southern Roots
              </h1>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-sm font-medium text-white hover:text-red-600 transition-colors whitespace-nowrap cursor-pointer">
                Home
              </Link>
              <Link to="/#product" className="text-sm font-medium text-white hover:text-red-600 transition-colors whitespace-nowrap cursor-pointer">
                Product
              </Link>
              <Link to="/blog" className="text-sm font-medium text-red-600 transition-colors whitespace-nowrap cursor-pointer">
                Recipes
              </Link>
              <Link to="/#story" className="text-sm font-medium text-white hover:text-red-600 transition-colors whitespace-nowrap cursor-pointer">
                Our Story
              </Link>
              <Link to="/#contact" className="text-sm font-medium text-white hover:text-red-600 transition-colors whitespace-nowrap cursor-pointer">
                Contact
              </Link>
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 rounded-lg hover:bg-gray-800 cursor-pointer"
            >
              <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl text-white`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-black border-t border-gray-800">
            <div className="px-4 py-4 space-y-3">
              <Link to="/" className="block w-full text-left text-sm font-medium text-white hover:text-red-600 py-2 cursor-pointer">
                Home
              </Link>
              <Link to="/#product" className="block w-full text-left text-sm font-medium text-white hover:text-red-600 py-2 cursor-pointer">
                Product
              </Link>
              <Link to="/blog" className="block w-full text-left text-sm font-medium text-red-600 py-2 cursor-pointer">
                Recipes
              </Link>
              <Link to="/#story" className="block w-full text-left text-sm font-medium text-white hover:text-red-600 py-2 cursor-pointer">
                Our Story
              </Link>
              <Link to="/#contact" className="block w-full text-left text-sm font-medium text-white hover:text-red-600 py-2 cursor-pointer">
                Contact
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center justify-center pt-20">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=rustic%20kitchen%20counter%20with%20fresh%20tomatoes%20herbs%20spices%20and%20cooking%20ingredients%20arranged%20beautifully%20with%20soft%20natural%20window%20light%20creating%20warm%20inviting%20culinary%20atmosphere%20with%20wooden%20cutting%20board&width=1920&height=800&seq=bloghero&orientation=landscape"
            alt="Recipe Blog"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Recipe Collection
          </h1>
          <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto font-light">
            Delicious recipes crafted with Southern Roots Bloody Mary Mix
          </p>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            From classic cocktails to creative dishes, discover new ways to enjoy our signature mix
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-red-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.map((post) => (
              <article
                key={post.id}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-1 cursor-pointer"
              >
                <div className="relative w-full h-64 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-center"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-red-600 text-white px-4 py-1 rounded-full text-xs font-semibold">
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center space-x-4 text-sm text-gray-500 mb-3">
                    <span className="flex items-center space-x-1">
                      <i className="ri-calendar-line"></i>
                      <span>{post.date}</span>
                    </span>
                    <span className="flex items-center space-x-1">
                      <i className="ri-time-line"></i>
                      <span>{post.readTime}</span>
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    {post.excerpt}
                  </p>
                  <button className="text-red-600 font-semibold hover:text-red-700 transition-colors flex items-center space-x-2 cursor-pointer">
                    <span>Read Recipe</span>
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-red-600 to-red-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Try These Recipes?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Get your Southern Roots Bloody Mary Mix today and start creating delicious cocktails and dishes
          </p>
          <Link
            to="/#product"
            className="inline-block bg-white text-red-600 px-10 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            Shop Now
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-amber-50 to-orange-50 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center space-y-6">
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/114092685085564"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-red-600 hover:bg-red-700 rounded-full flex items-center justify-center transition-colors cursor-pointer text-white"
              >
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a
                href="https://www.instagram.com/southernflavorr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-red-600 hover:bg-red-700 rounded-full flex items-center justify-center transition-colors cursor-pointer text-white"
              >
                <i className="ri-instagram-fill text-2xl"></i>
              </a>
              <a
                href="https://www.tiktok.com/@Southern.Roots29"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-red-600 hover:bg-red-700 rounded-full flex items-center justify-center transition-colors cursor-pointer text-white"
              >
                <i className="ri-tiktok-fill text-2xl"></i>
              </a>
            </div>
            <p className="text-gray-600 mb-4">
              Copyright © 2024 Southern Roots - All Rights Reserved.
            </p>
            <div className="flex justify-center space-x-6 text-sm text-gray-600">
              <a href="#" className="hover:text-red-600 transition-colors cursor-pointer">Privacy Policy</a>
              <span>•</span>
              <a href="#" className="hover:text-red-600 transition-colors cursor-pointer">Terms & Conditions</a>
              <span>•</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-red-600 transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
